import { blackFriday2026Config } from './blackFriday2026';
import { cancellationFlow } from './cancellation-flow';
import type { CouponConfig } from './interface';
import { monthlyNudgeConfig } from './monthlyNudge';
import { porkbunConfig } from './porkbun';
import { tryDuo2026Config } from './tryDuo2026';
import { tryMailPlus0724Config } from './tryMailPlus0724';
import { tryMailPlus0926Config } from './tryMailPlus0926';
import { tryMailPlusMobile2026Config } from './tryMailPlusMobile2026';
import { vpn15mConfig } from './vpn15m';

export const defaultCouponConfigs: CouponConfig[] = [
    monthlyNudgeConfig,
    vpn15mConfig,
    blackFriday2026Config,
    cancellationFlow,
    tryMailPlus0724Config,
    tryMailPlus0926Config,
    tryMailPlusMobile2026Config,
    porkbunConfig,
    tryDuo2026Config,
];
